import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import merge from 'lodash.merge';

import Wrapper from 'src/Wrapper';
import { traitPropType, stylePropType } from 'src/PropTypes';
import { Style1 } from 'src/styles';

/* eslint-disable no-nested-ternary */

const ZTABLE = {
  z: [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09],
  0: [0.5, 0.504, 0.508, 0.512, 0.516, 0.5199, 0.5239, 0.5279, 0.5319, 0.5359],
  0.1: [0.5398, 0.5438, 0.5478, 0.5517, 0.5557, 0.5596, 0.5636, 0.5675, 0.5714, 0.5753],
  0.2: [0.5793, 0.5832, 0.5871, 0.591, 0.5948, 0.5987, 0.6026, 0.6064, 0.6103, 0.6141],
  0.3: [0.6179, 0.6217, 0.6255, 0.6293, 0.6331, 0.6368, 0.6406, 0.6443, 0.648, 0.6517],
  0.4: [0.6554, 0.6591, 0.6628, 0.6664, 0.67, 0.6736, 0.6772, 0.6808, 0.6844, 0.6879],
  0.5: [0.6915, 0.695, 0.6985, 0.7019, 0.7054, 0.7088, 0.7123, 0.7157, 0.719, 0.7224],
  0.6: [0.7257, 0.7291, 0.7324, 0.7357, 0.7389, 0.7422, 0.7454, 0.7486, 0.7517, 0.7549],
  0.7: [0.758, 0.7611, 0.7642, 0.7673, 0.7704, 0.7734, 0.7764, 0.7794, 0.7823, 0.7852],
  0.8: [0.7881, 0.791, 0.7939, 0.7967, 0.7995, 0.8023, 0.8051, 0.8078, 0.8106, 0.8133],
  0.9: [0.8159, 0.8186, 0.8212, 0.8238, 0.8264, 0.8289, 0.8315, 0.834, 0.8365, 0.8389],
  1: [0.8413, 0.8438, 0.8461, 0.8485, 0.8508, 0.8531, 0.8554, 0.8577, 0.8599, 0.8621],
  1.1: [0.8643, 0.8665, 0.8686, 0.8708, 0.8729, 0.8749, 0.877, 0.879, 0.881, 0.883],
  1.2: [0.8849, 0.8869, 0.8888, 0.8907, 0.8925, 0.8944, 0.8962, 0.898, 0.8997, 0.9015],
  1.3: [0.9032, 0.9049, 0.9066, 0.9082, 0.9099, 0.9115, 0.9131, 0.9147, 0.9162, 0.9177],
  1.4: [0.9192, 0.9207, 0.9222, 0.9236, 0.9251, 0.9265, 0.9279, 0.9292, 0.9306, 0.9319],
  1.5: [0.9332, 0.9345, 0.9357, 0.937, 0.9382, 0.9394, 0.9406, 0.9418, 0.9429, 0.9441],
  1.6: [0.9452, 0.9463, 0.9474, 0.9484, 0.9495, 0.9505, 0.9515, 0.9525, 0.9535, 0.9545],
  1.7: [0.9554, 0.9564, 0.9573, 0.9582, 0.9591, 0.9599, 0.9608, 0.9616, 0.9625, 0.9633],
  1.8: [0.9641, 0.9649, 0.9656, 0.9664, 0.9671, 0.9678, 0.9686, 0.9693, 0.9699, 0.9706],
  1.9: [0.9713, 0.9719, 0.9726, 0.9732, 0.9738, 0.9744, 0.975, 0.9756, 0.9761, 0.9767],
  2: [0.9772, 0.9778, 0.9783, 0.9788, 0.9793, 0.9798, 0.9803, 0.9808, 0.9812, 0.9817],
  2.1: [0.9821, 0.9826, 0.983, 0.9834, 0.9838, 0.9842, 0.9846, 0.985, 0.9854, 0.9857],
  2.2: [0.9861, 0.9864, 0.9868, 0.9871, 0.9875, 0.9878, 0.9881, 0.9884, 0.9887, 0.989],
  2.3: [0.9893, 0.9896, 0.9898, 0.9901, 0.9904, 0.9906, 0.9909, 0.9911, 0.9913, 0.9916],
  2.4: [0.9918, 0.992, 0.9922, 0.9925, 0.9927, 0.9929, 0.9931, 0.9932, 0.9934, 0.9936],
  2.5: [0.9938, 0.994, 0.9941, 0.9943, 0.9945, 0.9946, 0.9948, 0.9949, 0.9951, 0.9952],
  2.6: [0.9953, 0.9955, 0.9956, 0.9957, 0.9959, 0.996, 0.9961, 0.9962, 0.9963, 0.9964],
  2.7: [0.9965, 0.9966, 0.9967, 0.9968, 0.9969, 0.997, 0.9971, 0.9972, 0.9973, 0.9974],
  2.8: [0.9974, 0.9975, 0.9976, 0.9977, 0.9977, 0.9978, 0.9979, 0.9979, 0.998, 0.9981],
  2.9: [0.9981, 0.9982, 0.9982, 0.9983, 0.9984, 0.9984, 0.9985, 0.9985, 0.9986, 0.9986],
  3: [0.9987, 0.9987, 0.9987, 0.9988, 0.9988, 0.9989, 0.9989, 0.9989, 0.999, 0.999],
  3.1: [0.999, 0.9991, 0.9991, 0.9991, 0.9992, 0.9992, 0.9992, 0.9992, 0.9993, 0.9993],
  3.2: [0.9993, 0.9993, 0.9994, 0.9994, 0.9994, 0.9994, 0.9994, 0.9995, 0.9995, 0.9995],
  3.3: [0.9995, 0.9995, 0.9995, 0.9996, 0.9996, 0.9996, 0.9996, 0.9996, 0.9996, 0.9997],
  3.4: [0.9997, 0.9997, 0.9997, 0.9997, 0.9997, 0.9997, 0.9997, 0.9997, 0.9997, 0.9998],
};

class NormalDistribution extends Component {
  static round(value, decimalPlaces) {
    const factor = 10 ** decimalPlaces;
    return Math.round(value * factor) / factor;
  }

  static getZScore(i, mean, standardDeviation) {
    return (i - mean) / standardDeviation;
  }

  static getPercentileForZScore(zScore) {
    let percentile = 0;
    if (zScore === 0) percentile = 50;
    else if (zScore <= -3.5) percentile = 0;
    else if (zScore >= 3.5) percentile = 100;
    else {
      const absZScore = Math.abs(zScore);
      const zRow = Math.floor(absZScore * 10) / 10;
      const zCol = NormalDistribution.round((Math.round(absZScore * 100) % 10) / 100, 2);
      const zColIndex = ZTABLE.z.indexOf(zCol);
      const absPercentile = ZTABLE[zRow.toString()][zColIndex];
      percentile = zScore < 0 ? (1 - absPercentile) * 100 : absPercentile * 100;
    }
    return percentile;
  }

  static getProbablityDensity(value, mean, standardDeviation) {
    const dividend = Math.E ** -((value - mean) ** 2 / (2 * standardDeviation ** 2));
    const divisor = standardDeviation * Math.sqrt(2 * Math.PI);
    return dividend / divisor;
  }

  render() {
    const { title, label: trait, value, mean, standardDeviation, style, options, onClick } = this.props;
    if (!trait || !value) {
      return <div>Loading</div>;
    }
    const x = [];
    let switched = false;
    let pass = false;
    let pop = false;
    const data1 = [];
    const scalePercentileMap = {
      1: { difference: Number.NegativeInfinity, found: false },
      10: { difference: Number.NegativeInfinity, found: false },
      20: { difference: Number.NegativeInfinity, found: false },
      30: { difference: Number.NegativeInfinity, found: false },
      40: { difference: Number.NegativeInfinity, found: false },
      60: { difference: Number.NegativeInfinity, found: false },
      70: { difference: Number.NegativeInfinity, found: false },
      80: { difference: Number.NegativeInfinity, found: false },
      90: { difference: Number.NegativeInfinity, found: false },
      99: { difference: Number.NegativeInfinity, found: false },
    };
    const scalePercentileKeys = Object.keys(scalePercentileMap);
    const deviations = [{ xAxis: '50.0' }];
    let point = [];
    for (let i = 0; i <= 100; i += 0.5) {
      const zScore = NormalDistribution.getZScore(i, mean, standardDeviation);
      const percentile = NormalDistribution.getPercentileForZScore(zScore);
      const probabilityDensity = NormalDistribution.getProbablityDensity(i, mean, standardDeviation);
      pass = false;
      pop = false;
      for (let j = 0; j < scalePercentileKeys.length; j += 1) {
        const key = scalePercentileKeys[j];
        const keyFloat = parseFloat(key);
        const newDifference = percentile - keyFloat;
        const { found, difference } = scalePercentileMap[key];
        if (!found) {
          if (newDifference > 0) {
            // we crossed the line . we need to figure the lower delta
            // If it is below the key, then we pop the old value
            // if it is above we add here and pass adding again
            scalePercentileMap[key].found = true;
            if (newDifference < Math.abs(difference)) {
              pass = true;
              scalePercentileMap[key].probabilityDensity = probabilityDensity;
              scalePercentileMap[key].percentile = percentile;
              scalePercentileMap[key].difference = newDifference;
            } else {
              pop = true;
            }
            if (pop) {
              const popped = x.pop();
              data1.pop();
              // if the popped value is the marked point we replace the
              // markpoint with the difference on the otherside
              if (popped.toFixed(1) === point[0]) {
                point = [keyFloat.toFixed(1), scalePercentileMap[key].probabilityDensity];
              }
            }
            x.push(keyFloat);
            data1.push(scalePercentileMap[key].probabilityDensity);
            if (percentile > value) {
              if (!switched) {
                point = [keyFloat.toFixed(1), scalePercentileMap[key].probabilityDensity];
                switched = true;
              }
            }
            deviations.push({
              xAxis: keyFloat.toFixed(1),
              label: {
                formatter:
                  keyFloat === 1
                    ? `(${trait.lowRangeName}) 1`
                    : keyFloat === 99
                      ? `99 (${trait.highRangeName})`
                      : keyFloat,
              },
            });
          } else {
            scalePercentileMap[key].probabilityDensity = probabilityDensity;
            scalePercentileMap[key].percentile = percentile;
            scalePercentileMap[key].difference = newDifference;
          }
        }
      }
      if (!pass) {
        x.push(percentile);
        data1.push(probabilityDensity);
        if (percentile > value) {
          if (!switched) {
            point = [percentile.toFixed(1), probabilityDensity];
            switched = true;
          }
        }
      }
    }
    const chartOption = {
      title: {
        text: title,
        ...style.global.title,
      },
      textStyle: {
        ...style.NormalDistribution.textStyle,
      },
      label: {
        ...style.NormalDistribution.label,
      },
      backgroundColor: style.global.backgroundColor,
      xAxis: [
        {
          data: x.map((val) => val.toFixed(1)),
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
      ],
      yAxis: [
        {
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
      ],
      series: [
        {
          type: 'line',
          symbol: 'none',
          data: data1,
          lineStyle: style.NormalDistribution.lineStyle,
          areaStyle: style.NormalDistribution.areaStyle(trait.factor),
          markLine: {
            data: deviations,
            ...style.NormalDistribution.markLine,
          },
          smooth: true,
          markPoint: {
            data: [
              {
                value: value.toFixed(1),
                xAxis: point[0],
                yAxis: point[1],
              },
            ],
            ...style.NormalDistribution.markPoint,
          },
          ...style.Nightingale.series,
        },
        /*
        {
          type: 'line',
          symbol: 'none',
          data: data2,
          areaStyle: style.NormalDistribution.areaStyle,
        },
        */
      ],
    };
    const mergedOptions = merge(chartOption, options);
    return (
      <Wrapper>
        <ReactEcharts
          ref={(element) => {
            const instance = element ? element.getEchartsInstance() : null;
            if (instance) {
              instance.off('click');
              instance.on('click', 'series', (params) => {
                onClick(params.data.code);
              });
            }
          }}
          style={{
            width: '100%',
            height: '100%',
          }}
          option={mergedOptions}
        />
      </Wrapper>
    );
  }
}

NormalDistribution.propTypes = {
  label: traitPropType.isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string,
  mean: PropTypes.number,
  standardDeviation: PropTypes.number,
  style: stylePropType,
  options: PropTypes.shape({}),
  onClick: PropTypes.func,
};

NormalDistribution.defaultProps = {
  mean: 50,
  standardDeviation: 17,
  style: Style1,
  title: '',
  options: {},
  onClick: () => null,
};

export default NormalDistribution;
